<template>
  <div
    class="margin-top-s"
    :class="{ 'margin-bottom-m': !badge.giftProducts[0]?.detail.description }"
    data-section="pricing-policy"
    data-auto="pricing-policy"
  >
    <label
      class="label"
      :class="{'loyallist-header' : !isMcom && badge.isLoyallistOffer}"
    > {{
      isMcom ?
        badge.header
        : badge.giftProducts[0]?.detail?.completeName
    }} </label>
    <p
      v-if="isMcom"
      class="regular margin-top-xs"
    >
      {{ badge.checkoutDescription }}
    </p>
    <p
      v-else
      class="regular margin-top-xs"
      v-html="sanitize(badge.giftProducts[0]?.detail?.description)"
    />
    <div class="gift-offer-subheader margin-top-xs">
      <div class="small gray">
        <p
          class="margin-bottom-xs gray"
          v-html="sanitize(badge.giftProducts[0]?.detail.name)"
        />
        <p>Web ID: {{ badge.giftProducts[0].id }}</p>
      </div>
      <img
        class="small-margin-top-s medium-margin-top-z"
        width="80"
        height="80"
        data-auto="giftPRoductImage"
        :src="imgSrc"
        :alt="imgAltText"
      >
    </div>
    <button
      v-show="!showViewMore && badge.giftProducts[0]?.detail.description"
      ref="viewMore"
      class="view-more-button link-sm margin-bottom-m"
      :aria-expanded="showViewMore"
      @click="toggleView"
    >
      View More
    </button>

    <template v-if="showViewMore && badge.giftProducts[0]?.detail.description">
      <div class="expanded-wrapper">
        <p
          v-if="isMcom"
          class="regular"
          data-auto="giftproduct-description"
        >
          {{ badge.giftProducts[0]?.detail.description }}
        </p>
        <ContentList
          :list="badge.giftProducts[0]?.detail.bulletText"
          class="list-wrapper regular padding-left-xs padding-top-xs"
        >
          <template #default="{ item }">
            <span v-html="sanitize(item)" />
          </template>
        </ContentList>
        <template v-if="badge.giftProductsLegalDisclaimer">
          <p class="disclaimer-wrapper small gray">
            {{ badge.giftProductsLegalDisclaimer }}
          </p>
        </template>
      </div>
    </template>
    <button
      v-show="showViewMore && badge.giftProducts[0]?.detail.description"
      ref="viewLess"
      class="view-less-button link-sm margin-bottom-m"
      :aria-expanded="showViewMore"
      @click="toggleView"
    >
      View Less
    </button>
  </div>
  <hr class="divider gray-background expanded margin-top-z margin-bottom-z">
</template>

<script setup>
import { ref, nextTick } from 'vue';
import { sanitize } from '@vue-util/sanitize';
import { brand } from 'config';
import ContentList from './ContentList';

const props = defineProps({
  badge: {
    /** @type import('vue').PropType<Badge> */
    type: Object,
    required: true,
  },
});

const isMcom = brand === 'mcom';
const imgSrc = `${props.badge?.giftProducts[0].urlTemplate.product || ''}${props.badge?.giftProducts[0].imagery.images[0].filePath || ''}?op_sharpen=1&wid=80&hei=80&fit=fit,1&$filtersmall$`;
const imgAltText = `${props.badge?.giftProducts[0].detail.name || ''} image`;
// TODO: make BadgeDetails and GiftBadgeDetails single component
const showViewMore = ref(false);
const viewMore = ref(null);
const viewLess = ref(null);

const toggleView = () => {
  showViewMore.value = !showViewMore.value;
  nextTick(() => {
    if (!showViewMore.value) viewMore.value?.focus();
    else viewLess.value?.focus();
  });
};
</script>

<style lang="scss" scoped>
@import "~settingSCSS";
@import "@core/csg/src/scss/typography/typography-mixins.scss";

.gift-offer-subheader {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: $gray-1-color;
}

.disclaimer-wrapper {
  @include margin-direction('top', map-get($spacer, 's'));
}

.gray {
  color: $gray-1-color;
}

@include breakpoint(medium up) {
  .gift-offer-subheader {
    flex-direction: row;
  }

  .disclaimer-wrapper {
    @include margin-direction('top', map-get($spacer, 'xs'));
  }
}
</style>

<style lang="scss" brand="mcom" scoped >
@import "~settingSCSS";
@import "@core/csg/src/scss/typography/typography-mixins.scss";

.list-wrapper {
  @include margin-direction('top', map-get($spacer, 'xxs'));
}

.expanded-wrapper {
  @include margin-direction('top', map-get($spacer, 's'));
}

@include breakpoint(medium) {
  .list-wrapper {
    @include margin-direction('top', 0);
  }
}
</style>
<style lang="scss" brand="bcom" scoped >
@import "~settingSCSS";
@import "@core/csg/src/scss/typography/typography-mixins.scss";

.expanded-wrapper {
  @include margin-direction('top', map-get($spacer, 'xxs'));
}

.loyallist-header {
  color: $loyalty-1-color;
}
</style>
